import { SETTINGS } from 'config/settings';

const pathHub = SETTINGS.public.pathHubWeb ?? '';
const urlPlan = SETTINGS.public.urlPlanWeb ?? '';
const urlAccountWeb = SETTINGS.public.urlAccountWeb ?? '';
const urlTelevet = SETTINGS.public.urlTelevetWeb ?? '';

export const routes = {
  home: `/home`,
  pathHub: `${pathHub}/home`,
  benefitUsage: '/benefit-usage',
  accounts: (accountId: string) => ({
    televeterinary: `/accounts/${accountId}/televeterinary`,
    assistance: `/accounts/${accountId}/assistance`,
    cremation: `/accounts/${accountId}/cremation`,
    payment_pending: `/accounts/${accountId}/payment-pending`,
  }),
  plan: urlPlan,
  links: {
    new: {
      card: `${urlAccountWeb}/links/new/card?redirect_to=${urlTelevet}`,
    },
  },
};
